import { useMemo } from 'react'
import useShortcuts from './useShortcuts'

const useReplacedText = (text, { extraShortcuts, scoreShortcuts, leadAnswerShortcuts, quizShortcuts } = {}) => {
	const shortcuts = useShortcuts(extraShortcuts)

	return useMemo(() => {
		if (typeof text !== 'string') {
			return text ?? ''
		}
		const matcher = new RegExp(`{([a-zA-z0-9_.-]+)}`, 'gi')

		const allShortcuts = {
			...shortcuts,
			...scoreShortcuts,
			...leadAnswerShortcuts,
			...quizShortcuts,
		}

		return text.replace(matcher, (match, shortcut) => {
			const value = allShortcuts[shortcut]

			return typeof value === 'number' || value ? value : ''
		})
	}, [leadAnswerShortcuts, quizShortcuts, scoreShortcuts, shortcuts, text])
}

export default useReplacedText
